import { ComponentProps, FormEvent } from "react";
import { SxProps, Theme } from "@mui/material";
import { useTranslation } from "next-i18next";
import { SwitchWithLabel } from "src/components-mui/base/switch-with-label/switch-with-label";
import { EnumCountryKey } from "src/types/common-enum";
import { useRouterLocale } from "src/utils/router/use-router-locale";
import { handleIsInvestableInCountry } from "../store/actions";
import { useSearchStore } from "../store/search-store";

interface IProps {
    trackHeight?: string;
    size?: ComponentProps<typeof SwitchWithLabel>["size"];
    fontSize?: keyof Theme["typography"];
    sx?: SxProps<Theme>;
}

export const InvestableInCountrySwitch = ({ sx, size = "small", fontSize = "sm" }: IProps) => {
    const { country } = useRouterLocale();
    const { isAtInvestable, isChInvestable } = useSearchStore();
    const { t } = useTranslation("extended-search");

    const onChange = (event: FormEvent<HTMLInputElement>) => {
        const isChecked = event.currentTarget.checked;
        handleIsInvestableInCountry({ isChecked, country });
    };

    switch (country) {
        case EnumCountryKey.AT:
            return (
                <SwitchWithLabel
                    checked={isAtInvestable}
                    onChange={onChange}
                    label={t("labels.investable-in-at")}
                    size={size}
                    fontSize={fontSize}
                    sx={sx}
                />
            );

        case EnumCountryKey.CH:
            return (
                <SwitchWithLabel
                    checked={isChInvestable}
                    onChange={onChange}
                    label={t("labels.investable-in-ch")}
                    size={size}
                    fontSize={fontSize}
                    sx={sx}
                />
            );

        default:
            return null;
    }
};
